const MIRROR_TO_LOCAL =
  String(process.env.REACT_APP_VISITOR_MIRROR_LOCAL_STORAGE || "").toLowerCase() === "true" ||
  process.env.REACT_APP_VISITOR_MIRROR_LOCAL_STORAGE === "1";

export const VISITOR_STORAGE_KEYS = {
  visitLogs: "visitor:visit-logs:v1",
  visitDraft: "visitor:visit-draft:v1",
  transactionProjects: "visitor:transaction-projects:v1",
};

const safeParse = (value, fallback) => {
  if (!value) return fallback;
  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};

const notifyStorageChange = (key) => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent("visitor-storage-updated", { detail: { key } }));
};

export function loadVisitorData(key, fallback) {
  if (typeof window === "undefined") return fallback;
  const sessionValue = window.sessionStorage.getItem(key);
  if (sessionValue !== null) return safeParse(sessionValue, fallback);
  const localValue = window.localStorage.getItem(key);
  if (localValue !== null) return safeParse(localValue, fallback);
  return fallback;
}

export function saveVisitorData(key, value) {
  if (typeof window === "undefined") return;
  const serialized = JSON.stringify(value);
  window.sessionStorage.setItem(key, serialized);
  if (MIRROR_TO_LOCAL) {
    window.localStorage.setItem(key, serialized);
  }
  notifyStorageChange(key);
}

export function clearVisitorData(key) {
  if (typeof window === "undefined") return;
  window.sessionStorage.removeItem(key);
  window.localStorage.removeItem(key);
  notifyStorageChange(key);
}
